
import axios from "axios";

export function executeStepFunction(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getNextQuestion`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
            throw err;
        });
}
